import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatTabsModule } from '@angular/material/tabs';
import { MatDialogModule } from '@angular/material/dialog';
import { MatTableModule } from '@angular/material/table';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatSelectModule } from '@angular/material/select';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDividerModule } from '@angular/material/divider';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { MatChipsModule } from '@angular/material/chips';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatRadioModule } from '@angular/material/radio';
import { MatListModule } from '@angular/material/list';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatBadgeModule } from '@angular/material/badge';
import { MatStepperModule } from '@angular/material/stepper';
import { MatBottomSheetModule } from '@angular/material/bottom-sheet';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FlexModule } from '@angular/flex-layout/flex';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatMenuModule } from '@angular/material/menu';
import { MatSnackBarModule} from '@angular/material/snack-bar';


@NgModule({
	declarations: [],
	imports: [
		CommonModule,
		MatIconModule,
		MatCardModule,
		MatFormFieldModule,
		MatInputModule,
		MatButtonModule,
		MatTabsModule,
		MatDialogModule,
		MatTableModule,
		MatToolbarModule,
		MatPaginatorModule,
		MatGridListModule,
		MatProgressBarModule,
		MatTooltipModule,
		MatCheckboxModule,
		MatSelectModule,
		MatDividerModule,
		DragDropModule,
		MatAutocompleteModule,
		MatChipsModule,
		MatExpansionModule,
		MatRadioModule,
		MatListModule,
		MatButtonToggleModule,
		MatSlideToggleModule,
		MatDatepickerModule,
		MatNativeDateModule,
		MatSidenavModule,
		MatBadgeModule,
		MatStepperModule,
		MatBottomSheetModule,
    FlexLayoutModule,
    FlexModule,
    MatProgressSpinnerModule,
    MatMenuModule,
    MatSnackBarModule,

	],
	exports: [
		MatIconModule,
		MatCardModule,
		MatFormFieldModule,
		MatInputModule,
		MatButtonModule,
		MatTabsModule,
		MatDialogModule,
		MatTableModule,
		MatToolbarModule,
		MatPaginatorModule,
		MatGridListModule,
		MatProgressBarModule,
		MatTooltipModule,
		MatCheckboxModule,
		MatSelectModule,
		MatDividerModule,
		DragDropModule,
		MatAutocompleteModule,
		MatChipsModule,
		MatExpansionModule,
		MatRadioModule,
		MatListModule,
		MatButtonToggleModule,
		MatSlideToggleModule,
		MatDatepickerModule,
		MatSidenavModule,
		MatBadgeModule,
		MatStepperModule,
		MatBottomSheetModule,
    FlexLayoutModule,
    FlexModule,
    MatProgressSpinnerModule,
    MatMenuModule,
    MatSnackBarModule,
	]
})
export class MaterialModule { }
